import React from 'react';
import { StickyTopBar } from './components/StickyTopBar';
import { HeroSection } from './components/HeroSection';
import { PainPointSection } from './components/PainPointSection';
import { SolutionSection } from './components/SolutionSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
import { RecentPurchaseToast } from './components/RecentPurchaseToast';
export function App() {
  return <div className="min-h-screen bg-light-gray flex flex-col font-body" data-id="element-0">
      <StickyTopBar data-id="element-1" />
      <RecentPurchaseToast data-id="element-2" />
      <main className="flex-grow pt-[40px] md:pt-[44px]" data-id="element-3">
        <HeroSection data-id="element-4" />
        <PainPointSection data-id="element-5" />
        <SolutionSection data-id="element-6" />
        <TestimonialsSection data-id="element-7" />
        <BonusSection data-id="element-8" />
        <PricingSection data-id="element-9" />
        <FinalCTASection data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}